export const common = {
  appName: 'NT Academy',
  yes: 'Yes',
  no: 'No',
  save: 'Save',
  cancel: 'Cancel',
  loading: 'Loading...',
  search: 'Search',
  searchPlaceholder: 'Type to search...',
  name: 'Name',
  status: 'Status',
  updatedAt: 'Updated at',
  optional: 'Optional',
  statuses: {
    active: 'Active',
    inactive: 'Inactive',
    draft: 'Draft',
    published: 'Published',
    archived: 'Archived',
  },
  roles: {
    aluno: 'Student',
    professor: 'Instructor',
    curador: 'Curator',
    admin: 'Admin',
  },
  prazo: {
    atrasado: 'Overdue',
    em_risco: 'At risk',
    no_prazo: 'On track',
  },
  tipo: {
    curso: 'Course',
    trilha: 'Track',
  },
  actions: {
    back: 'Back',
    retry: 'Try again',
    confirm: 'Confirm',
    close: 'Close',
    continue: 'Continue',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    create: 'Create',
    add: 'Add',
    publish: 'Publish',
    archive: 'Archive',
  },
  errors: {
    required: 'Required field',
    invalidEmail: 'Invalid email',
    network: 'Connection failed. Please try again.',
    generic: 'Something went wrong. Please try again.',
  },
  nav: {
    sidebar: 'Sidebar',
    inicio: 'Home',
    catalogo: 'Catalog',
    meusCertificados: 'My certificates',
    autoria: 'Authoring',
    curadoria: 'Curation',
    painelProfessor: 'Instructor panel',
    painelCurador: 'Curator panel',
    visaoGlobal: 'Global overview',
    usuarios: 'Users',
    language: 'Language',
    theme: 'Theme',
    userMenu: 'User menu',
  },
  themes: {
    light: 'Light',
    dark: 'Dark',
    system: 'System',
  },
  notFound: {
    title: 'Page not found',
    description: 'The page you are looking for does not exist or has been moved.',
    back: 'Back to home',
  },
  errorBoundary: {
    title: 'Something went wrong',
    description: 'An unexpected error occurred. Please reload the page and try again.',
    reload: 'Reload',
  },
  lesson: {
    videoUrlPlaceholder: 'Paste the YouTube or Vimeo URL',
    videoUrlLabel: 'Video URL',
    videoInsert: 'Insert',
    videoUnsupported: 'Unsupported provider. Use YouTube or Vimeo.',
  },
} as const;
